import template from "./entity-tokens.html";
import "./entity-tokens.less";
import { globs } from "../../../../../../services/globs";
import {
	FORM_ENTITY_TOKENS, 
	FORM_TOKEN_DEACTIVATE 
} from "../../../../../../routes";

export function controller(appState, loadingService, api, $logger, securityService) {
	const ctrl = this;

	ctrl.$onInit = () => {
		// type Token  = {
		// 	Id: number;
		// 	Code: string;
		//	Hash: string;
		// 	Created: string;
		//	IsActive: boolean;
		// };

		ctrl.tokens = [];  // Token[]

		loadTokens();
	};

	ctrl.deactivate = async(token) => {
		const canDeactivate = securityService.isActionAllowed(globs.tokens.byType(token.Code).deactivate);
		const canRead = securityService.isActionAllowed(globs.entityTypes.byType(ctrl.entity.Type.Code).tokens.byCode(token.Code).read);
		if(!canDeactivate || !canRead) {
			return;
		}

		const route = FORM_TOKEN_DEACTIVATE(appState.forms.selected.Id, token.Id);
		const promise = api.post(route);

		let newToken = await loadingService.watch(promise);
		if(newToken === undefined) {
			newToken = {
				Code: token.Code,
				CanDeactivate: false,
				IsActive: false
			};
		}

		const thisTokenIndex = ctrl.tokens.findIndex(t => t.Code === newToken.Code);
		ctrl.tokens[thisTokenIndex] = {
			...ctrl.tokens[thisTokenIndex],
			...newToken
		};

		checkForInactiveTokens();
	};

	async function loadTokens() {
		const route = FORM_ENTITY_TOKENS(appState.forms.selected.Id, ctrl.entity.Id);

		const promise = api.get(route);

		ctrl.tokens = await loadingService.watch(promise);

		ctrl.tokens = ctrl.tokens.filter(t => securityService.isActionAllowed(globs.entityTypes.byType(ctrl.entity.Type.Code).tokens.byCode(t.Code).read));
		ctrl.tokens.forEach(t => {
			t.CanDeactivate = t.IsActive && securityService.isActionAllowed(globs.tokens.byType(t.Code).deactivate);
		});

		checkForInactiveTokens();
	}

	function checkForInactiveTokens() {
		ctrl.hasInactiveTokens = ctrl.tokens.some(t => t.IsActive === false);	
	}
}

export default angular.module("vesl.components.entity-tokens", [])
	.component("entityTokens", {
		controller,
		template,
		bindings: {
			entity: "<"
		}
	})
	.name;
